export * from './src/angular-esri.module';